module.exports = __webpack_public_path__ + "static/media/desk.e3050870.svg";